import { axiosRequest } from './../../service/axios';

export default () => {
  const url = 'faq/list';
  const options = {
    method: 'get',
  };
  const axiosData = {
    url,
    options,
  };
  return axiosRequest(axiosData);
};
